import React, { PureComponent } from "react";
import { Select } from "antd";
import PropTypes from "prop-types";
import { updateFilters } from "./../../redux/actions/photothequeActions";
import connect from "react-redux/es/connect/connect";

class BestofFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ""
    };
  }

  onChange(values) {
    this.props.addFilter(values);
  }

  render() {
    const Option = Select.Option;
    const { placeholder, defaultValue } = this.props;
    const children = [];
    const filters = [
      {
        key: 2,
        value: "Tous"
      },
      {
        key: 0,
        value: "Non best of"
      },
      {
        key: 1,
        value: "Best of"
      }
    ];

    let i = 0;
    while (i < filters.length && children.length < 10) {
      const filter = filters[i];
      if (!filter) break;
      children.push(<Option key={filter.key}>{filter.value}</Option>);
      i++;
    }

    return (
      <Select
        // allowClear={true}
        filterOption={(input, option) => {
          return typeof option.props.children === "string"
            ? option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            : false;
        }}
        onFocus={() => {
          this.setState({
            searchValue: ""
          });
        }}
        onSearch={value => {
          this.setState({
            searchValue: value
          });
        }}
        mode="default"
        style={{ width: "100%" }}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onChange={v => {
          this.onChange(v);
        }}
      >
        {children}
      </Select>
    );
  }
}

BestofFilter.propTypes = {
  filterTargetKey: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

const mapStateToProps = (state, ownProps) => {
  return {
    currentFilters: state.phototheque.currentFilters ? state.phototheque.currentFilters[ownProps.filterTargetKey] : []
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addFilter: values => {
      dispatch(updateFilters(ownProps.filterTargetKey, values));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BestofFilter);



// WEBPACK FOOTER //
// src/components/phototheque/BestofFilter.js